import { connect } from 'react-redux';

import { openDialog } from '../../../actions/Dialog';

import { fetchItemsAdminPanel } from '../../../actions/AdminPanel';
import { publishModVersion } from '../../../actions/EditMod';

import ModeratorPanel from '../../../components/AdminPanel/ModeratorPanel/ModeratorPanel'
import DialogConfirmationModVersionRemove from '../../../containers/DialogConfirmationModVersionRemoveWrapper/DialogConfirmationModVersionRemoveWrapper';

const mapStateToProps = (state) => {
    const isLoggedIn = !!state.currentAccount.spaId;
    return ({
        isLoggedIn: isLoggedIn,
        spaId: state.currentAccount.spaId,
        spaUsername: state.currentAccount.spaUsername,

        isFetching: state.adminPanel.isFetching,
        isError: state.adminPanel.isError,
        filtered: state.adminPanel.filtered,
    })
}

const mapDispatchToProps = (dispatch) => ({
    fetchItemsAdminPanel: (filterParams) => {
        dispatch(fetchItemsAdminPanel(filterParams))
    },

    onIncrementDownloadCount: () => {
        //
    },
    onPublished: (modId) => {
        dispatch(publishModVersion(modId, "modId"))
    },
    onRejected: (modId) => {
        dispatch(openDialog(<DialogConfirmationModVersionRemove id={modId} isReject={true} type="modId" />))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(ModeratorPanel)
